import React from 'react';
import { Grid, Box, Typography, Stack } from '@mui/material';
import FormSectionHeader from '../../../components/common/FormSectionHeader';
import { sa, PillButton } from '../../../components/superAdminUi';

const Fact = ({ label, value }) => (
  <Stack direction="row" justifyContent="space-between" sx={{ mb: 0.5 }}>
    <Typography variant="body2" sx={{ fontFamily: sa.font.family, color: sa.color.textGray }}>{label}</Typography>
    <Typography variant="body2" sx={{ fontFamily: sa.font.family, fontWeight: sa.font.semibold, color: sa.color.text }}>{value || '—'}</Typography>
  </Stack>
);

const sectionTitleSx = {
  mb: 1,
  fontFamily: sa.font.family,
  fontWeight: sa.font.bold,
  color: sa.color.text,
};

// Step 2 of the school-edit wizard: read-only recap. Save lives in the wizard footer; on
// success this swaps to a confirmation panel.
export default function ReviewStep({ values, saved, onGoToSchool }) {
  if (saved) {
    return (
      <Box sx={{ p: 3, textAlign: 'center', fontFamily: sa.font.family }}>
        <Typography variant="h6" sx={{ mb: 1, fontFamily: sa.font.family, fontWeight: sa.font.bold, color: sa.color.text }}>
          School updated
        </Typography>
        <Typography variant="body2" sx={{ mb: 2, fontFamily: sa.font.family, color: sa.color.textGray }}>
          {values.Name} has been saved.
        </Typography>
        <PillButton type="button" $size="lg" onClick={onGoToSchool}>Back to school</PillButton>
      </Box>
    );
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FormSectionHeader title="Review & save" first />
      </Grid>

      <Grid item xs={12} md={6}>
        <Typography variant="subtitle2" sx={sectionTitleSx}>School</Typography>
        <Fact label="Name" value={values.Name} />
        <Fact label="URN" value={values.Urn} />
        <Fact label="Type" value={values.SchoolType} />
        <Fact label="Country" value={values.Country} />
        <Fact label="Pupils" value={values.NumberOfPupil} />
      </Grid>

      <Grid item xs={12} md={6}>
        <Typography variant="subtitle2" sx={sectionTitleSx}>Main contact</Typography>
        <Fact label="Name" value={`${values.FirstName} ${values.LastName}`.trim()} />
        <Fact label="Role" value={values.Role} />
        <Fact label="Contact number" value={values.ContactNumber} />
      </Grid>
    </Grid>
  );
}
